import { SHButton, SHDialog, SHStack, SHTypography } from "@components/design-systems";

interface InvalidPortfolioWarningDialogProps {
  open: boolean;
  onReturn?: () => void;
}
export default function InvalidPortfolioWarningDialog({
  open,
  onReturn,
}: InvalidPortfolioWarningDialogProps): JSX.Element {
  return (
    <SHDialog
      maxWidth="sm"
      width={1005}
      open={open}
      header={
        <SHStack
          alignItems="center"
          textAlign={"center"}
        >
          <SHTypography variant="h2" lineHeight={"120%"}>
            Each platform must have a valid portfolio
          </SHTypography>
        </SHStack>
      }
      body={
        <SHStack alignItems="center" textAlign={"center"}>
          <SHTypography variant="body2">
            Some platforms in your analysis do not have a valid portfolio
            assigned to them. Each platform must have a portfolio, and these
            portfolios must have investment options available on that platform.
          </SHTypography>
        </SHStack>
      }
      footer={
        <SHStack
          justifyContent="center"
          alignItems="center"
          direction={"row"}
          spacing={7}
        >
          <SHButton
            color="primary"
            variant="contained"
            size="extraMedium"
            onClick={onReturn}
          >
            Return to fee calculator
          </SHButton>
        </SHStack>
      }
    />
  );
}
